// extracted by mini-css-extract-plugin
export default {"code-editor-wrapper":"style_code-editor-wrapper__rn82x"};